(function () {
    'use strict';

    angular
        .module('aricControllers')
        .controller('AricControlCertificationController', Controller);

    Controller.$inject = ['$scope', 'aricControls', 'aricControl', 'controlOwnerAssessment', 'ownerAssessmentTypes']

    function Controller($scope, aricControls, aricControl, controlOwnerAssessment, ownerAssessmentTypes) {
        $scope.aricControls = aricControls;
        $scope.aricControl = aricControl;
        $scope.controlOwnerAssessment = controlOwnerAssessment;
        $scope.ownerAssessmentTypes = ownerAssessmentTypes;
    }
})();